import { ConsumptionOrdersService } from "./../../../services/documents/ConsumptionOrdersService";
import React from "react";
import { IAppEntity } from "../../entities";
import { CreateConsumptionOrders } from "../../../dtos/documents/ConsumptionOrders/CreateConsumptionOrders";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { NFLookupConsumptionOrders } from "../../../components/Shared/NewForms/NFLookupConsumptionOrders";
import {
  ConsumptionOrdersDetail
} from "../../../components/Pages/Documents/Warehouse/ConsumptionOrders/ConsumptionOrdersDetail";
import ConsumptionOrdersList
  from "../../../components/Pages/Documents/Warehouse/ConsumptionOrders/ConsumptionOrdersList";

export const ConsumptionOrders: IAppEntity = {
  entityType: "document",
  title: "Consumption Orders",
  pluralTitle: "Consumption Orders",
  apiUrl: "ConsumptionOrders",
  apiEnum: ReferenceTypes.DocumentConsumptionOrder,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(ConsumptionOrdersDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(ConsumptionOrdersList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupConsumptionOrders, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new ConsumptionOrdersService("ConsumptionOrders"),
  getEmptyModel: () => {
    const model: CreateConsumptionOrders = {
      totalAmount: 0,
      totalAmountVat: 0,
      documentDate: new Date(),
      desiredConsumptionDate: new Date(),
      createdDate: new Date(),
      documentNumber: "",
      status: 0,
      comment: "",
      companyId: "",
      divisionId: "",
      
      consumptionOrdersGoods: [],
    };
    return model;
  },
};
